<div class="benefitItemContainer">
  <div class="imageContainer"
      [ngStyle]="{'background-image': 'linear-gradient(0deg, rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(' + backgroundImage + ') '}">

    <!--<img [src]="backgroundImage" alt="" class="backgroundImage" />-->
    <div class="svgOverlay">
      <app-cosentino-svg [svgName]="this.getIcon()" [size]="24"></app-cosentino-svg>
      <div class="titleItem typography-title-m">{{ title }}</div>
    </div>
  </div>
  <div class="subtitleContainer typography-body-m-regular text-justify">
    {{ subtitle }}
  </div>
  <ng-container *ngIf="btnName && showButton">
    <app-link (onClick)="handleItemClick(btnName)" size="medium">
      {{ btnName }}
    </app-link>
  </ng-container>
</div>
